import React, { memo } from "react";
import DropdownButton from "../../../components/DropdownButtonMC";
import Alert from "../../../../components/shared/Alert";
import useCustomerOrderStatusActions from "../../../hooks/inbox/actions/useCustomerOrderStatusActions";
import useCustomerOrderStatusUI from "../../../hooks/inbox/ui/useCustomerOrderStatusUI";
import LoadingMC from "../../../components/LoadingMC";
import { useTraceUpdate } from '../../../hooks/shared/useDebugRenders';

/**
 * Componente Molecule optimizado para selección y cambio de estado de orden de cliente.
 * Separa lógica de negocio (Actions Layer) y lógica UI (UI Layer) según estándares Mercately.
 *
 * @component CustomerOrderStatusSelectorMC
 * @category Component - Molecule
 * @since 1.0.0
 * @version 2.0.0 - Refactor separación de capas y optimización de performance
 */
const CustomerOrderStatusSelectorMC = memo(({ order, updateOrderInList }) => {
  // Actions Layer: lógica de negocio (guardar estado)
  const {
    loading,
    updateOrderStatus
  } = useCustomerOrderStatusActions({ order, updateOrderInList });

  // UI Layer: estado visual y handlers UI
  const {
    confirmAlertRef,
    alertTitle,
    alertMessage,
    orderStatusLabel,
    orderStatusOptions,
    containerClassNameStatus,
    handleConfirm,
    handleCancel
  } = useCustomerOrderStatusUI({ order, updateOrderStatus });

  // Debug tracking de dependencias críticas
  useTraceUpdate('CustomerOrderStatusSelectorMC', {
    orderId: order?.id,
    orderStatus: order?.status,
    loading
  }, {
    logRenderCount: true,
    logPropChanges: true
  });

  if (loading) return <LoadingMC loading={loading} spinnerClassName="!tw-w-4 !tw-h-4" />;

  return (
    <>
      <DropdownButton
        variant="TEXT_PLAIN"
        text={orderStatusLabel}
        items={orderStatusOptions}
        containerClassName={containerClassNameStatus}
        className={`!tw-h-[20px] !tw-min-h-0 !tw-py-1 !tw-px-1 ${containerClassNameStatus}`}
      />
      <Alert
        ref={confirmAlertRef}
        title={alertTitle}
        message={alertMessage}
        type="confirm"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
});

CustomerOrderStatusSelectorMC.displayName = 'CustomerOrderStatusSelectorMC';

export default CustomerOrderStatusSelectorMC;
